import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';
import React, { useState } from 'react';
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  MinusOutlined,
  PlusOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import CourierAndOrderFormControls from './CourierAndOrderFormControls';
import { useTranslation } from 'react-i18next';
import {
  switchOrdersForCourier,
  transferOrdersForCourier,
} from '../../../../store/requests/routing';
import { SELECT_DISTRIBUTOR } from '../../../../helpers/constants';

const { Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;

export const ChangeDistributor = ({
  routeTask,
  routeReasonTypes,
  isReRoutingRequired,
  setIsModalOpen,
  routeId,
  setAgainRouting,
  reRoutingReq,
  allCourierOfStore,
}) => {
  const { t } = useTranslation();
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [destinationCouriers, setDestinationCouriers] = useState([]);
  const [destinationOrders, setDestinationOrders] = useState([]);
  const [selectedCouriers, setSelectedCouriers] = useState([]);
  const [
    selectedCouriersForDoubleDistributorForm,
    setSelectedCouriersForDoubleDistributorForm,
  ] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [shareDistributorForm] = Form.useForm();
  const [doubleDistributorForm] = Form.useForm();
  const [
    calculatedDestinationOrdersForShowButton,
    setCalculatedDestinationOrdersForShowButton,
  ] = useState([]);
  const onFinish = (value) => {
    let payloadData;
    if (selectedDistributor === SELECT_DISTRIBUTOR.DOUBLE_DISTRIBUTOR) {
      payloadData = {
        ...value,
        routeTaskId: +routeId,
      };
      switchOrdersForCourier(payloadData)
        .then((res) => {
          showConfirm(payloadData);
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else if (selectedDistributor === SELECT_DISTRIBUTOR.SHARE_DISTRIBUTOR) {
      payloadData = {
        ...value,
        destinationDetails: value.destinationDetails.map((destination) => ({
          destinationCourierId: destination.courier,
          orderIds: destination.orders,
        })),
        routeTaskId: +routeId,
      };
      transferOrdersForCourier(payloadData)
        .then((res) => {
          showConfirm(payloadData);
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  };

  const showConfirm = (payloadData) => {
    confirm({
      title: t('routingDetail.againRouting'),
      icon: <ExclamationCircleOutlined />,
      content: t('routingDetail.againRoutingDesc'),
      cancelText: t('routingDetail.changeRedistributor'),
      okText: t('routingDetail.againRouting'),
      onOk() {
        reRoutesFn();
      },
      onCancel() {
        setIsModalOpen(false);
        shareDistributorForm.resetFields();
        doubleDistributorForm.resetFields();
        setAgainRouting(true);
      },
    });
  };

  const reRoutesFn = () => {
    reRoutingReq().then(() => {
      shareDistributorForm.resetFields();
      doubleDistributorForm.resetFields();
    });
  };

  const radioOptions = [
    {
      label: t('routingDetail.doubleDistributor'),
      value: SELECT_DISTRIBUTOR.DOUBLE_DISTRIBUTOR,
      disabled: routeTask?.routeTaskDetails?.length < 2,
    },
    {
      label: t('routingDetail.shareDistributor'),
      value: SELECT_DISTRIBUTOR.SHARE_DISTRIBUTOR,
      disabled: false,
    },
  ];

  const selectedSourceCourier = (value) => {
    doubleDistributorForm.resetFields(['secondCourierId']);
    const filteredDestinationOrders = routeTask?.routeTaskDetails
      .filter((courier) => courier.courierId === value)[0]
      .orders?.filter((b) => !b?.actualOrderDeliveryTime);
    setDestinationCouriers(
      allCourierOfStore?.filter((courier) => courier.id !== value),
    );
    setSelectedCouriersForDoubleDistributorForm(
      routeTask?.routeTaskDetails.filter(
        (courier) => courier.courierId !== value,
      ),
    );
    setDestinationOrders(filteredDestinationOrders);
  };

  const onFormValuesChange = async () => {
    const destinationDetails =
      shareDistributorForm.getFieldsValue().destinationDetails;
    setSelectedCouriers(destinationDetails?.map((dd) => dd?.courier));
    setSelectedOrders(
      destinationDetails
        .filter((detail) => detail && detail.orders && detail.orders.length > 0)
        .map((detail) => detail.orders),
    );
  };
  const checkValidator = (_, value) => {
    if (value?.courier && value?.orders && value?.orders.length > 0) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(t('routingDetail.courierAndOrderRequired')),
    );
  };

  const modalCancel = () => {
    setIsModalOpen(false);
    shareDistributorForm.resetFields();
    doubleDistributorForm.resetFields();
  };

  const againRouting = () => {
    if (isReRoutingRequired) {
      reRoutesFn();
    }
  };

  return (
    <Modal
      width={1200}
      closable={false}
      title={t('routingDetail.changeDistributor')}
      open={true}
      footer={[
        <Button key="back" onClick={modalCancel}>
          {t('cancel')}
        </Button>,
        isReRoutingRequired && (
          <Button
            icon={<RedoOutlined />}
            type="primary"
            danger
            onClick={againRouting}
          >
            {t('routingDetail.againRouting')}
          </Button>
        ),
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            if (selectedDistributor === SELECT_DISTRIBUTOR.DOUBLE_DISTRIBUTOR) {
              doubleDistributorForm.submit();
            } else if (
              selectedDistributor === SELECT_DISTRIBUTOR.SHARE_DISTRIBUTOR
            ) {
              shareDistributorForm.submit();
            }
          }}
        >
          {t('save')}
        </Button>,
      ]}
    >
      <Row>
        <Col span={8}>
          <Card style={{ width: '100%', height: '100%' }}>
            <Radio.Group
              style={{ display: 'flex', flexDirection: 'column' }}
              options={radioOptions}
              onChange={(e) => setSelectedDistributor(e.target.value)}
              value={selectedDistributor}
              optionType="default"
              buttonStyle="outline"
            >
              <Space direction="vertical">
                {radioOptions.map((option) => (
                  <Radio
                    key={option.value}
                    disabled={option.disabled}
                    value={option.value}
                  >
                    {option.label}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Card>
        </Col>
        <Col span={16}>
          {selectedDistributor === null && (
            <Card
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              size="small"
            >
              <Text mark>
                <ArrowLeftOutlined />
                {t('routingDetail.selectChangeDistributorOptions')}
              </Text>
            </Card>
          )}
          {selectedDistributor === SELECT_DISTRIBUTOR.DOUBLE_DISTRIBUTOR && (
            <Card
              style={{ width: '100%' }}
              size="small"
              title={
                <Alert
                  showIcon
                  message={
                    <span style={{ whiteSpace: 'pre-wrap' }}>
                      {t('routingDetail.doubleDistributorDesc')}
                    </span>
                  }
                  type="warning"
                />
              }
            >
              <Form
                form={doubleDistributorForm}
                layout="vertical"
                name="dynamic_form_nest_item"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Form.Item
                  name="firstCourierId"
                  label="Kaynak Dağıtıcı"
                  rules={[
                    {
                      required: true,
                      message: t('routingDetail.reqSourceCourier'),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    onChange={selectedSourceCourier}
                    filterOption={(input, option) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {routeTask?.routeTaskDetails?.map((courier) => (
                      <Option key={courier.courierId} value={courier.courierId}>
                        {courier.courierName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  style={{ width: '100%' }}
                  name="secondCourierId"
                  label={t('routingDetail.selectDestinationCourier')}
                  rules={[
                    {
                      required: true,
                      message: t('routingDetail.reqSelectDestinationCourier'),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ width: '100%' }}
                  >
                    {selectedCouriersForDoubleDistributorForm?.map(
                      (courier) => (
                        <Option
                          key={courier.courierId}
                          value={courier.courierId}
                        >
                          {courier.courierName}
                        </Option>
                      ),
                    )}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="reasonId"
                  label={t('routingDetail.reasonForChange')}
                  rules={[
                    {
                      required: true,
                      message: t('routingDetail.reqReasonForChange'),
                    },
                  ]}
                >
                  <Select
                    className="fullWidth"
                    filterOption={(input, option) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {routeReasonTypes?.map((reason) => (
                      <Option key={reason?.id} value={reason.id}>
                        {t(`routingDetail.${reason?.reasonCode}`)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            </Card>
          )}

          {selectedDistributor === SELECT_DISTRIBUTOR.SHARE_DISTRIBUTOR && (
            <Card
              style={{ width: '100%' }}
              size="small"
              title={
                <Alert
                  showIcon
                  message={
                    <span style={{ whiteSpace: 'pre-wrap' }}>
                      {t('routingDetail.shareDistributorDesc')}
                    </span>
                  }
                  type="warning"
                />
              }
            >
              <Form
                form={shareDistributorForm}
                name="dynamic_form_nest_item"
                onFinish={onFinish}
                onValuesChange={onFormValuesChange}
                autoComplete="off"
                initialValues={{ destinationDetails: [''] }}
              >
                <Form.Item
                  name="sourceCourierId"
                  label={t('routingDetail.sourceCourier')}
                  rules={[
                    {
                      required: true,
                      message: t('routingDetail.reqSourceCourier'),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    onChange={selectedSourceCourier}
                    filterOption={(input, option) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {routeTask?.routeTaskDetails?.map((courier) => (
                      <Option key={courier.courierId} value={courier.courierId}>
                        {courier.courierName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Card style={{ marginBottom: '10px' }}>
                  <Form.List name="destinationDetails">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key}>
                            <Col span={22}>
                              <Form.Item
                                style={{ width: '100%' }}
                                name={name.toString()}
                                rules={[
                                  {
                                    validator: checkValidator,
                                  },
                                  {
                                    required: true,
                                    message: '',
                                  },
                                ]}
                              >
                                <CourierAndOrderFormControls
                                  destinationCouriers={destinationCouriers}
                                  selectedCouriers={selectedCouriers}
                                  destinationOrders={destinationOrders}
                                  selectedOrders={selectedOrders}
                                  index={name}
                                  setCalculatedDestinationOrdersForShowButton={
                                    setCalculatedDestinationOrdersForShowButton
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col span={1} offset={1}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                {key !== 0 && (
                                  <Button
                                    danger
                                    shape="circle"
                                    icon={<MinusOutlined />}
                                    style={{ marginRight: '2px' }}
                                    onClick={() => remove(name)}
                                  />
                                )}
                                {selectedOrders.flat().length !==
                                  destinationOrders.length &&
                                  calculatedDestinationOrdersForShowButton.length >
                                    1 && (
                                    <Button
                                      type="primary"
                                      shape="circle"
                                      icon={<PlusOutlined />}
                                      onClick={() => add()}
                                    />
                                  )}
                              </div>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Card>

                <Form.Item
                  name="reasonId"
                  label={t('routingDetail.reasonForChange')}
                  rules={[
                    {
                      required: true,
                      message: t('routingDetail.reqReasonForChange'),
                    },
                  ]}
                >
                  <Select
                    className="fullWidth"
                    showSearch
                    filterOption={(input, option) =>
                      (option?.children ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {routeReasonTypes?.map((reason) => (
                      <Option key={reason?.id} value={reason.id}>
                        {t(`routingDetail.${reason?.reasonCode}`)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </Modal>
  );
};
